import { selectTutorDsReading } from "../../featureFlags/tutorDsFF"

/**
 * La route `menu` montre-t-elle la coquille de l'espace tuteur (`TutorNavigator`), l'attend-elle, ou
 * garde-t-elle l'ancienne ? Un tuteur hors live : `"on"` si l'interrupteur `tutor_ds` est relu
 * allumé pour son compte, `"pending"` tant qu'il n'est pas relu pour lui (juste après une
 * connexion, `selectTutorDsReading`), sinon `"off"`. Lu par la bascule de `BottomTabsNavigator` et
 * par l'en-tête de la route, qui s'efface devant celui de la coquille (et pendant l'attente).
 */
export const tutorShellFor = (state) =>
    state.liveMode?.isLiveModeEnabled ? "off" : selectTutorDsReading(state)
